<template>
  <div style="width: 250px">
    <div class="row align-items-center">
      <div class="col-md-8">
        <select
          v-model="selectedFile"
          class="form-select style-select"
          aria-label="Pilih File"
        >
          <option disabled value="">- Pilih File -</option>
          <option
            v-for="item in availableFiles"
            :key="item.value"
            :value="item.value"
            :disabled="!item.url"
          >
            {{ item.label }}
          </option>
        </select>
      </div>

      <div class="col-md-4 mt-2">
        <a
          v-if="activeDownloadUrl"
          :href="activeDownloadUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i
            :class="downloadIconClass"
            aria-hidden="true"
            style="font-size: 20px"
            data-toggle="tooltip"
            data-placement="top"
            :title="downloadTitle"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FileDownloadDropdown',
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  computed: {
    selectedFile: {
      get() {
        return this.data.selectedFile || ''
      },
      set(val) {
        this.$set(this.data, 'selectedFile', val)
      },
    },

    availableFiles() {
      const isSwasta = this.data.tipe_pemohon === 'Swasta'

      const files = [
        {
          value: 'verdok',
          label: 'Verdok',
          url: this.data.file_ba_verdok,
          title: 'Unduh file verifikasi dokumen',
          icon: 'fa fa-cloud-download',
        },
      ]

      // Opsi Tagihan & Pembayaran hanya dimasukkan jika tipe_pemohon adalah 'Swasta'
      if (isSwasta) {
        files.push(
          {
            value: 'tagihan_1',
            label: 'Tagihan 1',
            url: this.data.file_tagihan_i,
            title: 'Unduh file tagihan 1',
            icon: 'fa fa-cloud-download',
          },
          {
            value: 'tagihan_2',
            label: 'Tagihan 2',
            url: this.data.file_tagihan_ii,
            title: 'Unduh file tagihan 2',
            icon: 'fa fa-cloud-download',
          },
          {
            value: 'tagihan_3',
            label: 'Tagihan 3',
            url: this.data.file_tagihan_iii,
            title: 'Unduh file tagihan 3',
            icon: 'fa fa-cloud-download',
          },
          {
            value: 'pembayaran',
            label: 'Bukti Penerimaan Negara(SIMPONI)',
            url: this.data.bukti_pembayaran,
            title: 'Unduh file bukti pembayaran',
            icon: 'fa fa-cloud-download',
          },
           {
            value: 'pembayaran',
            label: 'Bukti Pembayaran',
            url: this.data.bukti_pembayaran_pemohon,
            title: 'Unduh file bukti pembayaran',
            icon: 'fa fa-cloud-download',
          }
        )
      }

      

      // Gabungkan opsi file lainnya
      files.push(
        {
          value: 'surattugas',
          label: 'Surat Tugas',
          url: this.data.filename_final_surat_tugas || this.data.filename_konsep_surat_tugas,
          title: 'Unduh file surat tugas',
          icon: 'fa fa-cloud-download',
        },
        {
          value: 'undangan',
          label: 'Undangan',
          url: this.data.filename_final_undangan || this.data.filename_konsep_undangan,
          title: 'Unduh file undangan',
          icon: 'fa fa-cloud-download',
        },
        {
          value: 'ba',
          label: 'Berita Acara',
          url: this.data.file_ba_vertek,
          title: 'Unduh file berita acara',
          icon: 'fa fa-cloud-download',
        },
        {
          value: 'ba_penolakan',
          label: 'Berita Acara Penolakan',
          url: this.data.file_ba_tidak_bayar,
          title: 'Unduh file berita acara penolakan',
          icon: 'fa fa-cloud-download',
        },
        {
          value: 'shp',
          label: 'File SHP',
          url: this.data.file_shp,
          title: 'Unduh file SHP',
          icon: 'fa fa-cloud-download',
        },
        {
          value: 'resume',
          label: 'Resume Permohonan',
          url: this.data.file_resume_permohonan,
          title: 'Unduh file resume permohonan',
          icon: 'fa fa-cloud-download',
        },
        {
          value: 'persetujuan',
          label: 'Surat Persetujuan',
          url: this.data.file_persetujuan,
          title: 'Unduh file persetujuan',
          icon: 'fa fa-cloud-download',
        },
        {
          value: 'final-persetujuan',
          label: 'Final Surat Persetujuan',
          url: this.data.file_izin_ttd,
          title: 'Unduh file persetujuan',
          icon: 'fa fa-cloud-download',
        }
      )

      return files
    },

    selectedFileObj() {
      return this.availableFiles.find((item) => item.value === this.selectedFile)
    },

    activeDownloadUrl() {
      return this.selectedFileObj ? this.selectedFileObj.url : null
    },

    downloadTitle() {
      return this.selectedFileObj ? this.selectedFileObj.title : ''
    },

    downloadIconClass() {
      return this.selectedFileObj ? this.selectedFileObj.icon : 'fa fa-cloud-download'
    },
  },
}
</script>

<style scoped>
.style-select {
  width: 150px;
  margin-right: 10px;
}
</style>